var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFEBFF"
    },
    points: "256,223.677 229.073,263.276 282.927,263.276 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#557DE6"
    },
    points: "229.073,263.276 211.649,288.619 300.351,288.619 282.927,263.276 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M262.891,261.063c0.107-0.222,0.22-0.438,0.317-0.664 C263.112,260.623,262.998,260.842,262.891,261.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M263.633,259.238c0.066-0.199,0.146-0.392,0.203-0.594 C263.778,258.845,263.698,259.038,263.633,259.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.975,262.724c0.136-0.217,0.27-0.433,0.397-0.655 C262.246,262.292,262.11,262.508,261.975,262.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M266.091,255.347c-0.241,0-0.472,0.04-0.685,0.111C265.619,255.386,265.85,255.347,266.091,255.347 L266.091,255.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M264.83,255.765c-0.335,0.262-0.565,0.627-0.617,1.043l-0.001,0.002l0.001-0.002 C264.266,256.392,264.494,256.026,264.83,255.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M264.013,267.584c0.377,0.358,0.751,0.698,1.127,1.024c2.01-1.74,4.108-3.951,5.58-6.538 c-0.106,0.185-0.22,0.365-0.332,0.546c-1.375-2.528-2.101-4.715-2.453-6.012c-0.201-0.74-0.967-1.256-1.842-1.257 C266.43,258.302,267.154,263.73,264.013,267.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M271.98,259.238c0.066-0.199,0.146-0.392,0.203-0.594 C272.126,258.845,272.046,259.038,271.98,259.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M273.178,255.765c-0.335,0.262-0.565,0.627-0.617,1.043v0.002v-0.002 C272.614,256.392,272.842,256.026,273.178,255.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M271.239,261.063c0.107-0.222,0.22-0.438,0.317-0.664 C271.459,260.623,271.346,260.842,271.239,261.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M288.339,269.612c-3.053,0-5.942-1.465-7.706-3.958c-2.657-3.754-3.862-7.254-4.349-9.049 c-0.201-0.742-0.969-1.258-1.845-1.258l0.003,0.001c0.401,3.526,1.358,10.575-4.371,14.264h-3.73 c-0.153-0.121-0.302-0.237-0.459-0.365c0.003,0.003,0.007,0.007,0.01,0.009c-1.044,1.363-3.132,1.745-4.751,0.91 c-6.778-3.492-5.726-11.11-5.303-14.818c-0.875,0.001-1.641,0.516-1.842,1.257c-0.352,1.297-1.078,3.484-2.453,6.012 c-0.111-0.182-0.226-0.361-0.331-0.546c1.656,2.91,4.113,5.366,6.333,7.186c-1.044,1.363-3.132,1.745-4.751,0.91 c-6.779-3.492-5.726-11.11-5.304-14.818c-0.875,0.001-1.641,0.516-1.842,1.257c-0.352,1.297-1.078,3.484-2.452,6.012 c-0.111-0.182-0.226-0.361-0.332-0.546c1.656,2.91,4.113,5.366,6.333,7.186c-1.044,1.363-3.132,1.745-4.751,0.91 c-6.778-3.492-5.726-11.11-5.303-14.818l0.003-0.001c-0.876,0-1.644,0.515-1.845,1.258c-0.487,1.796-1.692,5.295-4.349,9.049 c-1.763,2.493-4.652,3.958-7.706,3.958h-2.508v3.168h64.943h1.583v-3.168h-0.925V269.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M258.723,260.398c0.097,0.226,0.21,0.444,0.317,0.664 C258.934,260.842,258.82,260.623,258.723,260.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M258.098,258.643c0.056,0.202,0.137,0.395,0.203,0.594 C258.234,259.038,258.154,258.845,258.098,258.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M257.719,256.81v-0.002c-0.052-0.416-0.28-0.781-0.617-1.043c0.335,0.262,0.565,0.627,0.617,1.043 V256.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M259.56,262.07c0.127,0.223,0.262,0.438,0.397,0.655C259.821,262.508,259.687,262.292,259.56,262.07 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.015,264.265c-0.017-0.021-0.031-0.043-0.047-0.065c0.136-0.181,0.266-0.363,0.397-0.548 c-0.13,0.184-0.264,0.366-0.398,0.546c-0.136-0.18-0.269-0.361-0.398-0.546C260.714,263.86,260.862,264.063,261.015,264.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M261.711,265.142c0.154,0.185,0.308,0.37,0.466,0.548 C262.019,265.512,261.865,265.327,261.711,265.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M263.403,267c-0.148-0.148-0.292-0.303-0.438-0.456C263.112,266.698,263.255,266.852,263.403,267z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M274.442,255.348l-0.003-0.001c-0.481,0-0.925,0.157-1.261,0.418 c-0.335,0.262-0.565,0.627-0.617,1.043v0.002c-0.078,0.625-0.211,1.234-0.378,1.833c-0.056,0.202-0.137,0.395-0.203,0.594 c-0.13,0.392-0.262,0.782-0.424,1.161c-0.097,0.226-0.21,0.444-0.317,0.664c-0.164,0.34-0.332,0.679-0.519,1.007 c-1.472,2.586-3.57,4.798-5.58,6.538c-0.375-0.324-0.749-0.665-1.127-1.024c3.14-3.853,2.417-9.282,2.081-12.236l-0.003-0.001 c-0.241,0-0.472,0.04-0.685,0.111c-0.213,0.072-0.408,0.177-0.576,0.307c-0.335,0.262-0.565,0.627-0.617,1.043l-0.001,0.002 c-0.078,0.625-0.211,1.234-0.378,1.833c-0.056,0.202-0.137,0.395-0.203,0.594c-0.129,0.392-0.262,0.782-0.424,1.161 c-0.097,0.226-0.21,0.444-0.317,0.664c-0.164,0.34-0.332,0.679-0.519,1.007c-0.127,0.223-0.262,0.438-0.397,0.655 c-0.196,0.314-0.397,0.625-0.61,0.927c-0.13,0.185-0.262,0.369-0.397,0.548c-0.136-0.181-0.27-0.363-0.401-0.548 c-0.213-0.302-0.414-0.612-0.61-0.927c-0.136-0.217-0.27-0.433-0.397-0.655c-0.188-0.329-0.354-0.667-0.519-1.007 c-0.107-0.222-0.22-0.438-0.317-0.664c-0.162-0.378-0.295-0.769-0.424-1.161c-0.066-0.199-0.146-0.392-0.203-0.594 c-0.168-0.598-0.3-1.208-0.378-1.833v-0.002c-0.052-0.417-0.28-0.781-0.617-1.043s-0.779-0.418-1.26-0.418l-0.003,0.001 c-0.422,3.709-1.475,11.326,5.303,14.818c1.143,0.589,2.515,0.566,3.591,0.024c0.687-0.346,1.425-0.578,2.194-0.578h3.146 C275.8,265.923,274.844,258.873,274.442,255.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M249.749,258.643c0.056,0.202,0.137,0.395,0.203,0.594 C249.886,259.038,249.806,258.845,249.749,258.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M249.37,256.81l-0.001-0.002c-0.052-0.416-0.28-0.781-0.617-1.043 c0.335,0.262,0.565,0.627,0.617,1.043L249.37,256.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M250.376,260.398c0.097,0.226,0.21,0.444,0.317,0.664 C250.585,260.842,250.473,260.623,250.376,260.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M247.494,255.347L247.494,255.347c0.241,0,0.472,0.04,0.685,0.111 C247.965,255.386,247.734,255.347,247.494,255.347z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M252.793,270.165c1.62,0.834,3.708,0.452,4.751-0.91c-2.22-1.82-4.676-4.275-6.333-7.186 c-0.188-0.329-0.354-0.666-0.519-1.007c-0.107-0.222-0.22-0.438-0.317-0.664c-0.162-0.378-0.295-0.769-0.424-1.161 c-0.066-0.199-0.146-0.392-0.203-0.594c-0.168-0.598-0.3-1.208-0.378-1.833l-0.001-0.002c-0.052-0.417-0.28-0.781-0.617-1.043 c-0.168-0.13-0.363-0.235-0.576-0.307s-0.444-0.111-0.685-0.111l0,0l-0.003,0.001l0,0 C247.068,259.057,246.015,266.673,252.793,270.165z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M241.401,258.643c0.056,0.202,0.137,0.395,0.203,0.594 C241.538,259.038,241.458,258.845,241.401,258.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M242.028,260.398c0.097,0.226,0.21,0.444,0.317,0.664 C242.238,260.842,242.124,260.623,242.028,260.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M241.023,256.81v-0.002c-0.052-0.416-0.28-0.781-0.617-1.043c0.335,0.262,0.565,0.627,0.617,1.043 V256.81z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M244.446,270.165c1.62,0.834,3.708,0.452,4.751-0.91c-2.22-1.82-4.676-4.275-6.333-7.186 c-0.186-0.329-0.354-0.666-0.519-1.007c-0.107-0.222-0.22-0.438-0.317-0.664c-0.162-0.378-0.295-0.769-0.424-1.161 c-0.066-0.199-0.146-0.392-0.203-0.594c-0.168-0.598-0.3-1.208-0.378-1.833v-0.002c-0.052-0.417-0.28-0.781-0.617-1.043 c-0.335-0.262-0.779-0.418-1.26-0.418l-0.003,0.001C238.72,259.057,237.666,266.673,244.446,270.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M242.655,242.752c-0.131,0.505-0.264,1.011-0.395,1.516c4.324-1.297,9.096-2.076,14.274-2.076 c5.177,0.003,9.95,0.776,14.274,2.076c-0.131-0.505-0.264-1.011-0.395-1.516c-4.301-1.11-8.93-1.748-13.879-1.746 C251.586,241.005,246.957,241.642,242.655,242.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AA0E6"
    },
    d: "M242.827,242.093c-0.131,0.505-0.264,1.011-0.395,1.516c4.276-1.3,8.99-2.08,14.102-2.082 c5.113,0.002,9.826,0.781,14.102,2.082c-0.131-0.505-0.264-1.011-0.395-1.516c-4.253-1.118-8.823-1.751-13.707-1.752 C251.649,240.342,247.08,240.978,242.827,242.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC800"
    },
    d: "M242.986,241.484c-0.131,0.505-0.264,1.011-0.395,1.516c4.234-1.304,8.892-2.09,13.943-2.088 c5.053,0,9.71,0.783,13.943,2.088c-0.131-0.505-0.264-1.011-0.395-1.516c-4.207-1.117-8.723-1.759-13.548-1.759 C251.709,239.724,247.194,240.366,242.986,241.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE14E"
    },
    d: "M243.167,240.788c-0.131,0.505-0.264,1.011-0.395,1.516c4.184-1.309,8.78-2.095,13.762-2.095 c4.982,0.002,9.578,0.786,13.762,2.095c-0.131-0.505-0.264-1.011-0.395-1.516c-4.158-1.122-8.609-1.764-13.367-1.766 C251.776,239.023,247.324,239.666,243.167,240.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB14E"
    },
    d: "M243.346,240.104c-0.131,0.505-0.264,1.011-0.395,1.516c4.136-1.312,8.668-2.101,13.583-2.102 c4.915,0.003,9.448,0.788,13.583,2.102c-0.131-0.505-0.264-1.011-0.395-1.516c-4.106-1.124-8.497-1.772-13.188-1.773 C251.843,238.334,247.453,238.977,243.346,240.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M243.421,239.812c-0.093,0.354-0.184,0.708-0.277,1.062c4.082-1.314,8.55-2.111,13.389-2.11 c4.841-0.002,9.308,0.793,13.389,2.11c-0.093-0.354-0.184-0.707-0.277-1.062c-4.085-1.127-8.45-1.774-13.112-1.775 C251.871,238.034,247.507,238.684,243.421,239.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M300.352,290.157h-88.703c-0.585,0-1.121-0.322-1.397-0.835c-0.275-0.516-0.244-1.141,0.079-1.628 l44.352-66.527c0.588-0.878,2.048-0.878,2.636,0l44.352,66.527c0.323,0.486,0.354,1.111,0.078,1.628 C301.473,289.836,300.936,290.157,300.352,290.157z M214.607,286.989h82.785L256,224.902L214.607,286.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M259.029,248.932c0-1.394-1.412-3.512-3.673-3.512c-1.321,0-2.392,0.808-2.392,1.803 c0,0.498,0.267,0.947,0.698,1.273c-0.002,0.019-0.003,0.038-0.004,0.055c-0.54,0.331-0.892,0.829-0.892,1.394 c0,0.95,0.979,1.72,2.216,1.79l1.018,2.036l0.919-1.838C258.126,251.626,259.029,250.401,259.029,248.932z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/ni.c131542492e82f334013321ef1254ca5.svg";
export { ForwardRef as ReactComponent };